// data.ts

export type BDEPerformance = {
    id: string;
    name: string;
    code: string;
    targetsAchieved: number; // Stored as a decimal (e.g., 1.05 for 105%)
};

export type PerformanceCardConfig = {
    title: string;
    data: BDEPerformance[];
    isHighPerforming: boolean;
};

// Data extracted from the image
const highPerformingBDEs: BDEPerformance[] = [
    { id: '1', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 1.05 },
    { id: '2', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 1.01 },
    { id: '3', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 0.97 },
    { id: '4', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 1.00 },
];

const lowPerformingBDEs: BDEPerformance[] = [
    { id: '5', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 0.54 },
    { id: '6', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 0.65 },
    { id: '7', name: 'Sarah Lee', code: 'AG-0000', targetsAchieved: 0.67 },
];

export const performanceDashboardConfig: PerformanceCardConfig[] = [
    {
        title: 'High Performing BDEs',
        data: highPerformingBDEs,
        isHighPerforming: true,
    },
    {
        title: 'Low Performing BDEs',
        data: lowPerformingBDEs,
        isHighPerforming: false,
    },
];